<template>
    <div class="flex items-center justify-end space-x-4">
        <ui-button-new small icon="fa fa-undo"
                       @click="undo"
                       @mousedown="disableStateTracking"
                       :disabled="undosAvailable()?false:true"
                       v-if="!applicationForPayment.readonly"
        >Undo {{ undosAvailable() ? '(' + undosAvailable() + ')' : '' }}
        </ui-button-new>
        <ui-button-new small icon="fa fa-repeat"
                       @click="redo"
                       @mousedown="disableStateTracking"
                       :disabled="redosAvailable()?false:true"
                       v-if="!applicationForPayment.readonly"
        >Redo {{ redosAvailable() ? '(' + redosAvailable() + ')' : '' }}
        </ui-button-new>
        <div class="flex">
            <ui-dropdown placement="bottom-end" menu-class="p-3 w-72" :key="userKey">
                <template #default="{ toggle }">
                    <ui-button-new @click="toggle" small primary>
                        Actions
                        <i class="flex-shrink-0 ml-2 fa fa-chevron-down"></i>
                    </ui-button-new>
                </template>

                <template #menu="{ close }">
                    <ui-dropdown-item icon="fas fa-share"
                                      @click="$modals.open('applicationForPayment-send', {item: applicationForPayment, close:$emit('packageUpdated')})">
                        Send
                    </ui-dropdown-item>
                    <ui-dropdown-item icon="fas fa-file-pdf" @click="download">Download as PDF</ui-dropdown-item>
                    <ui-dropdown-item icon="fas fa-print" @click="print">Print PDF</ui-dropdown-item>
                    <ui-dropdown-item v-if="!applicationForPayment.readonly" danger icon="fa fa-trash" @click="deleteApplicationForPayment">Delete
                    </ui-dropdown-item>
                    <ui-dropdown-divider
                        v-if="(user && applicationForPayment && !applicationForPayment.locked && applicationForPayment.editing && (applicationForPayment.editingBy !== user.id))"></ui-dropdown-divider>
                    <ui-dropdown-item
                        v-if="(user && applicationForPayment && !applicationForPayment.locked && applicationForPayment.editing && (applicationForPayment.editingBy !== user.id))"
                        danger icon="fa fa-lock-open" @click="releaseLock">Force Un-lock of Edit mode
                    </ui-dropdown-item>
                </template>
            </ui-dropdown>
        </div>
    </div>
</template>

<script>
import {ApplicationForPayment} from "../../../models";
import UiDropdownItem from "../../ui/UiDropdownItem.vue";
import UiButtonNew from "../../ui/UiButtonNew.vue";
import {cloneDeep} from "lodash";
import remoteStorage from "../../../utils/remoteStorage";
import UiDropdownDivider from "../../ui/UiDropdownDivider.vue";
import {readonly} from "vue";

export default {
    components: {UiDropdownDivider, UiButtonNew, UiDropdownItem},
    props: {
        applicationForPayment: ApplicationForPayment,
        user: Object,
    },
    data() {
        return {
            states: [],
            position: 0,
            selectedPage: [],
            userKey: 1,
        }
    },
    watch: {
        'applicationForPayment.readonly': {
            handler(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.applicationForPayment.clearSnapshots(0);
                    this.applicationForPayment.addSnapshot(true);
                    this.states = this.applicationForPayment.getSnapshotStore().states;
                    this.position = this.states.length - 1;
                }
            },
        },
    },
    computed: {
    },
    methods: {
        deleteApplicationForPayment() {
            this.$modals.confirmDelete({
                title: `Delete Application for Payment #${this.applicationForPayment.reference}`,
                button: 'Yes, delete Application for Payment',
                handle: async () => {
                    await this.applicationForPayment.delete()
                    this.$emit('deleted', this.applicationForPayment.id)
                }
            })
        },
        duplicate() {
            this.$emit('duplicate', this.applicationForPayment.id, true)
        },
        undosAvailable() {
            return this.states.length - this.redosAvailable() - 1
        },
        redosAvailable() {
            return this.states.length - this.position - 1
        },
        disableStateTracking() {
            this.applicationForPayment.disableSnapshots = true;
            document.activeElement.blur();
        },
        undo() {
            Object.assign(this.applicationForPayment, JSON.parse(this.states[--this.position]))
            this.applicationForPayment.save();
            this.applicationForPayment.disableSnapshots = false;
            this.applicationForPayment.buildCollectedItems();
            this.$emit('reflow')
        },
        redo() {
            Object.assign(this.applicationForPayment, JSON.parse(this.states[++this.position]))
            this.applicationForPayment.save();
            this.applicationForPayment.disableSnapshots = false;
            this.applicationForPayment.buildCollectedItems();
            this.$emit('reflow')
        },
        print() {
            this.$emit('print', this.applicationForPayment.getPrintableUrl())
        },
        download() {
            window.location.href = this.applicationForPayment.getDownloadUrl()
        },
        releaseLock() {
            this.$modals.confirm({
                title: `Force Unlock of Edit mode for this Application For Payment?`,
                paragraphs: ['This Application for Payment is currently locked for editing by another user.', 'Force unlocking of edit mode WILL force that user out of edit mode for this applicationForPayment and may result in that user loosing any unsaved work.', 'Please attempt to contact the user first and only use this as a last resort.', 'Are you sure you want to proceed?'],
                button: 'Yes, unlock it',
                handle: async () => {
                    await this.applicationForPayment.releaseEditLock()
                    close();
                },
            })
        },
    },
    mounted() {
        eventBus.$on('application-for-payment-history-state-updated', (data) => {
            if (data.applicationForPayment === this.applicationForPayment) {
                if (this.position + 1 !== data.states.length - 1) {
                    this.applicationForPayment.clearSnapshots(this.position + 1, data.states.length - this.position - 2);
                    data = this.applicationForPayment.getSnapshotStore();
                    this.states = data.states
                    this.position = data.states.length - 1;
                    this.$forceUpdate();
                } else {
                    this.states = data.states
                    this.position = data.states.length - 1;
                }
            }
        });
        this.applicationForPayment.clearSnapshots(0);
        this.applicationForPayment.addSnapshot();
        this.states = this.applicationForPayment.getSnapshotStore().states;
        this.position = this.states.length - 1;
    }
}
</script>
